import { Navigate, Outlet } from 'react-router-dom';

import { routes } from '@/navigation/routes.tsx';
import { useAuth } from '@/hooks/useAuth';

export const RegistrationRoute = () => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to={routes.login} replace />;
  }

  return <Outlet />;
};
